<template>
  <div class="book-parking">
    <div class='book-parking-header'>
      <img src="../images/kk-logo-white.png" alt="KIRURGIKLINIK"/>
      <img src="../images/bloodworks-logo.png" alt="BLOODWORKS"/>
    </div>
    <div class='book-parking-content'>
      <v-container>
        <v-form ref="bookForm" v-model="formValid">
          <v-row justify="center">
            <v-col cols="12" md="9">
              <div class="book-parking-title">REGISTRER DIN BIL HER</div>
              <v-row align='center'>
                <v-col cols="12" md="3" class='py-0'><span class='book-parking-label'>Din nummerplade:</span></v-col>
                <v-col cols="12" md="9">
                  <v-text-field v-model="licensePlate" :loading='carInfoLoading' @input='initGetCarInfo();resetSubmitButton();resetConfirmationMessage();resetErrorMessage()' @keyup.enter="submitForm" outlined/>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-alert v-if='carInfo' color="primary" outlined text>{{carInfo}}</v-alert>
                  <v-alert v-else-if='licensePlate && !carInfo' color="primary" outlined text>Nummerpladen kan ikke findes, tjek venligst igen. Hvis du mener det er korrekt, har du muligheden for at booke alligevel</v-alert>
                  <v-alert v-else-if='confirmationMessage' color="primary" type="success" class='white--text text-uppercase'>{{confirmationMessage}}</v-alert>
                </v-col>
              </v-row>
              <v-row align='center'>
                <v-col cols="12" md="6" class='py-0'>
                  <v-row align='center' class='my-0'>
                    <v-col cols="12" md="6" class='py-0'><span class='book-parking-label'>Mobilnummer:</span></v-col>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="mobilePhone" @input='resetSubmitButton();resetConfirmationMessage();resetErrorMessage()' @keyup.enter="submitForm" outlined :rules="[rules.required, rules.phoneNumber]"/>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" class='py-0'>
                  <v-row align='center' class='my-0'>
                    <v-col cols="12" md="6" class='py-0'><span class='book-parking-label'>Bekræft mobilnr.:</span></v-col>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="confirmMobilePhone" @input='resetSubmitButton();resetConfirmationMessage();resetErrorMessage()' @keyup.enter="submitForm" outlined :rules="[rules.required, rules.matchMobilePhone]"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row align='center'>
                <v-col cols="12" md="3" class='py-0'><span class='book-parking-label'>Booking dato:</span></v-col>
                <v-col cols="12" md="9">
                  <v-menu ref="menuFrom" v-model="menuFrom" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field :value="formattedBookingDateTime" class="datepicker-input" append-icon="mdi-calendar" @click:append="menuFrom = true" readonly v-on="on" outlined :rules="[rules.required]"/>
                    </template>
                    <v-date-picker v-model="bookingDateTime" :min="new Date().toISOString().split('T')[0]" no-title @change="menuFrom = false;resetSubmitButton();resetConfirmationMessage();resetErrorMessage()" color="primary lighten-0"/>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row v-if='errorMessage' justify='end'>
                <v-col cols="12" md="7">
                  <div class='book-parking-error-message'>{{errorMessage}}</div>
                </v-col>
              </v-row>
              <v-row align='center' justify='end'>
                <v-col cols="12" sm="7">
                  <v-btn block depressed x-large :color="submitButtonColor" :loading='submitLoading' :disabled='submitLoading' @click="submitForm">
                    BEKRÆFT PARKERING
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </div>
  </div>
</template>

<script>
  import api from '@/api/api';
  import methods from '@/utils/methods';
  import validationRules from '../utils/validationRules';

  export default {
    name: 'BookParking',

    metaInfo: {
      meta: [
        {
          name: 'robots',
          content: 'noindex'
        }
      ]
    },

    data: function () {
      return {
        formValid: false,
        licensePlate: '',
        mobilePhone: '',
        confirmMobilePhone: '',
        bookingDateTime: new Date().toISOString().split('T')[0],
        menuFrom: false,
        carInfo: null,
        carInfoLoading: false,
        submitLoading: false,
        submitButtonColor: 'primary',
        confirmationMessage: '',
        confirmationTimeout: null,
        errorMessage: '',
      };
    },

    computed: {
      rules: function () {
        return {
          ...validationRules,
          phoneNumber: value => {
            const pattern = /^\+?[0-9]*$/;
            return !value || pattern.test(value) || 'Vær opmærksom på at dette felt er til telefonnummer. Prøv venligst igen.';
          },
          matchMobilePhone: value => value === this.mobilePhone || 'Mobilnumre skal være ens'
        };
      },
      formattedBookingDateTime: function () {
        if (this.bookingDateTime) {
          return methods.formatDate(this.bookingDateTime);
        } else {
          return '';
        }
      },
    },

    methods: {
      clearForm: function () {
        this.licensePlate = '';
        this.mobilePhone = '';
        this.confirmMobilePhone = '';
        this.bookingDateTime = new Date().toISOString().split('T')[0];
        this.carInfo = null;
        this.$refs.bookForm.resetValidation();
      },
      resetSubmitButton: function() {
        this.submitButtonColor = 'primary';
      },
      resetConfirmationMessage: function() {
        this.confirmationMessage = '';
        if (this.confirmationTimeout) {
          clearTimeout(this.confirmationTimeout);
          this.confirmationTimeout = null;
        }
      },
      resetErrorMessage: function() {
        this.errorMessage = '';
      },
      initGetCarInfo: function() {
        this.carInfo = null;
        if (this.licensePlate?.length >= 4) {
          this.getCarInfo();
        }
      },
      queryData: function() {
        const queryData = {};
        queryData.licensePlate = this.licensePlate?.toUpperCase();
        queryData.mobilePhone = this.mobilePhone;
        queryData.confirmMobilePhone = this.confirmMobilePhone;
        queryData.bookingDateTime = this.bookingDateTime;
        return queryData;
      },
      submitForm: async function () {
        this.$refs.bookForm.validate();
        if (!this.formValid) return;
        // Clear any existing timeout
        if (this.confirmationTimeout) {
          clearTimeout(this.confirmationTimeout);
          this.confirmationTimeout = null;
        }

        try {
          this.submitLoading = true;
          await api.setParkingBooking(this.queryData());
          this.confirmationMessage = `PARKERING FOR: ${this.licensePlate} ER BEKRÆFTET - TJEK SMS`;
          this.clearForm();
          this.confirmationTimeout = setTimeout(() => {
            this.resetConfirmationMessage();
          }, 15000);
        } catch (e) {
          this.submitButtonColor = 'error';
          if (e.response.status === 401) {
            this.errorMessage = 'Du kan desværre ikke bruge parkerings-appen. Din IP adresse er ikke whitelistet. Kontakt support@kirurgiklinik.dk hvis du har spørgsmål.';
          } else {
            this.errorMessage = methods.getErrors(e.response);
          }
        } finally {
          this.submitLoading = false;
        }
      },
      getCarInfo: async function () {
        try {
          this.carInfoLoading = true;
          const carData = await api.getCarInfo(this.licensePlate?.toUpperCase());
          carData.data && (this.carInfo = carData.data);
        } catch (e) {
          this.carInfo = null;
        } finally {
          this.carInfoLoading = false;
        }
      }
    },
  };
</script>

<style lang="scss" scoped>
  .book-parking {
    background: white;
    min-height: 100vh;
    display: flex;
    flex-direction: column;

    &-header {
      background: #233241;
      min-height: 100px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: flex-end;
      gap: 50px;
      padding: 20px 0;
      margin-bottom: auto;

      @media only screen and (max-width: 767px) {
        gap: 20px;
      }

      img {
        width: 150px;
        height: auto;
        display: block;

        @media only screen and (max-width: 767px) {
          width: calc(50% - 20px);
          max-width: 150px;
        }
      }
    }

    &-content {
      background: white;
      display: flex;
      flex-grow: 1;
      flex-direction: column;
      justify-content: center;
    }

    &-title {
      font-size: 35px;
      line-height: 1.2;
      font-weight: 700;
      color: #0d3651;
      text-transform: uppercase;
      text-align: center;
      margin-bottom: 40px;

      @media only screen and (max-width: 767px) {
        font-size: 20px;
      }
    }

    &-label {
      display: block;
      font-size: 18px;
      line-height: 1.2;
      font-weight: 700;
      color: #0d3651;
      margin-bottom: 30px;

      @media only screen and (max-width: 767px) {
        font-size: 16px;
        margin-bottom: 0;
      }
    }

    &-error-message {
      color: red;
      font-size: 18px;
      font-weight: 700;
      text-align: center;
    }
  }
</style>
